import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerRegistrationService} from '../../services/customer-registration/customer-registration.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AgencyMaster, Organization, StateCountry} from '../../shared/common-components/common-structure';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {DataService} from '../../services/data.service';
import {CustomerRegistration} from './customer-registration';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {of, Observable, BehaviorSubject} from 'rxjs';
import AppConstants from '../../shared/common-components/AppConstants';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {RatesSroMasterService} from 'src/app/services/rates-sro-master/rates-sro-master.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-customer-registration',
    templateUrl: './customer-registration.component.html',
    styleUrls: ['./customer-registration.component.css'],
    standalone: false
})
export class CustomerRegistrationComponent implements OnInit, OnDestroy {

  registrationSuccessful = false;
  invalidEmail: any;
  registrationFailure = false;
  agencyMaster: AgencyMaster[];
  bureauMaster: any;
  repOfficialList: Organization[];
  emailPresent: any;
  permission: string[] = ['FRT', 'HHG'];
  userPermission = [];
  stateList: StateCountry[] = null;
  countryList:  StateCountry[] = null;
  countryListObs = new BehaviorSubject<Object>(null);
  registrationId: any = 0;
  stateCountryType: any;
  savedCustomer: CustomerRegistration;
  registerDetails: any;
  organizationDetails: any = 0;
  confirmDateValue: any = 0;
  selectedRegisterId: any = null;
  uspsData: any;
  showDropDownMessage: any;
  customerRegistrationForm: UntypedFormGroup;
  isCountryUsa = true;
  registrationStatus: String;
  typeaheadOriginLoading: boolean;
  stateCountry: any;
  dataSourceOrigin: Observable<any>;
  permissionRadio = [
    {key: 'FRT', text: 'Freight '},
    {key: 'HHG', text: 'Household Goods'},
  ];
  constructor(private customerRegistrationService: CustomerRegistrationService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private dataService: DataService,
              private router: Router,
              private route: ActivatedRoute,
              private stateCountryService: StateCountryService,
              private ratesSroMasterService: RatesSroMasterService) {
    this.createForm();
    this.customerRegistrationForm.get('country').setValue(null);
    this.registrationId = '';
  }

  ngOnInit() {
    const params = this.route.snapshot.queryParams['userregisterid'];
    this.getCountryList();
    if (params !== undefined) {
      this.registrationId = params;
      this.customerRegistrationForm.controls['userRegisterId'].setValue(this.registrationId);
      this.customerRegistrationForm.controls['userConfirmation'].setValue('Yes');
      // this.getRegistrationDetails(this.registrationId);
    } else {
      this.permissionControls();
    }

    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.customerRegistrationForm.get('asyncOriginSearchString').value).subscribe((result: any) => {
        observer.next(result);
      });
    });

    this.customerRegistrationForm.get('originCity').valueChanges.subscribe(origin => {
      this.tmssLoader.show();
      if (origin) {
        this.customerRegistrationForm.get('city').setValue(origin.cityName);
        this.customerRegistrationForm.get('state').setValue(origin.stateAbbrev);
        this.stateCountryService.getStateCountryByStateCountryCode(
          origin.stateAbbrev).subscribe(
          stateCountry => {
            this.stateCountry = stateCountry;
            this.customerRegistrationForm.controls['stateId'].setValue(
              this.stateCountry.stateCountryId);
            this.tmssLoader.hide();
          }, (error) => {
            this.alertService.error('Error while getting origin city and state.');
            this.tmssLoader.hide();
          }
        );
        this.customerRegistrationForm.get('stateId').setValue(origin.stateId);
        this.customerRegistrationForm.get('zip').setValue(origin.zipCode);
      }
    });
    this.isCountryUsa = true;
    this.customerRegistrationForm.get('country').setValue(null);
    this.setDefaultCountry();
  }


  setDefaultCountry() {
    this.countryListObs.pipe(filter(value => value != null))
      .subscribe(defaultCountry => {
        const objCountry = Object.values(defaultCountry).find(obj => obj.stateCountryName === 'UNITED STATES');
        if (this.customerRegistrationForm.get('country')) {
          this.customerRegistrationForm
            .get('country')
            .setValue(objCountry.stateCountryId);
        }
      });
  }


  createForm() {
    this.customerRegistrationForm = this.fb.group({
      userConfirmation: '',
      userRegisterId: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email, CommonValidators.specialEmail]),
      businessType: new UntypedFormControl('', [Validators.required]),
      registrationType: new UntypedFormControl(null, Validators.required),
      registerTypeReadOnly: new UntypedFormControl(''),
      agencyCodeReadOnly: new UntypedFormControl(''),
      bureauCodeReadOnly: new UntypedFormControl(''),
      agencyName: new UntypedFormControl(''),
      bureauName: new UntypedFormControl(''),
      repOfficialReadOnly: new UntypedFormControl(''),
      permissionReadOnly: new UntypedFormControl(''),
      emailReadonly: new UntypedFormControl(''),
      agency: new UntypedFormControl(null, Validators.required),
      agencyCode: new UntypedFormControl(''),
      bureauCode: new UntypedFormControl('', Validators.required),
      reportingOfficialId: new UntypedFormControl(null, Validators.required),
      userPermission: new UntypedFormArray([]),
      frtAccess: [null, [Validators.required]],
      hhgAccess: [null, [Validators.required]],
      permissions: [null, [Validators.required]],
      firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]),
      middleInitial: new UntypedFormControl(''),
      title: new UntypedFormControl('', [Validators.required]),
      addressLine1: new UntypedFormControl('', [Validators.required]),
      addressLine2: new UntypedFormControl(''),
      asyncOriginSearchString: new UntypedFormControl(null, []),
      originCity: new UntypedFormControl(null, []),
      city: new UntypedFormControl('', [Validators.required]),
      state: new UntypedFormControl('', [Validators.required]),
      stateId: new UntypedFormControl(null, []),
      zip: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), CommonValidators.numeric]),
      zipSuffix: new UntypedFormControl('', [CommonValidators.numeric, Validators.minLength(4), Validators.maxLength(4)]),
      country: new UntypedFormControl(null, Validators.required),
      phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10), CommonValidators.numeric]),
      phoneExtension: new UntypedFormControl('', [CommonValidators.numeric]),

    });
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    console.log(e);
    this.customerRegistrationForm.get('originCity').setValue(e.item);
  }


  /*
  * Permission arry construction
  */
  permissionControls() {
    of(this.getPermissions()).subscribe(x => {
      this.userPermission = x;
      this.addCheckboxes();
    });
  }

  addCheckboxes() {
    this.userPermission.map((o, i) => {
      const control = new UntypedFormControl(i === 0); // if first item set to true, else false
      (this.customerRegistrationForm.controls.userPermission as UntypedFormArray).push(control);
    });
  }

  /*
  * Get the Permission
  */

  getPermissions() {
    return [
      {name: 'HHG'},
      {name: 'FRT'}
    ];
  }

  /*
  * Permission Selected
  */
  permissionsSelected() {
    if (this.customerRegistrationForm.get('registrationType').value === 'User') {
      return false;
    }
    let flag = false;

    if(!this.customerRegistrationForm.controls['permissions'].value){
      flag = true;
    }
    /*if (!this.customerRegistrationForm.controls['frtAccess'].value && !this.customerRegistrationForm.controls['hhgAccess'].value) {
      flag = true;
    }*/
    if (flag) {
      this.customerRegistrationForm.setErrors({'incorrect': true});
    } else {
      this.customerRegistrationForm.controls['permissions'].setErrors(null);
      this.customerRegistrationForm.controls['frtAccess'].setErrors(null);
      this.customerRegistrationForm.controls['hhgAccess'].setErrors(null);
      this.customerRegistrationForm.controls['userPermission'].setErrors(null);
    }
    return flag;
  }

  /*Get confirmation for the registration from the user.*/
  getConfirmationResponse() {
    this.tmssLoader.show();
    this.customerRegistrationForm.controls['userRegisterId'].setErrors(null);
    this.tmssLoader.hide();
  }

  /*
  *  Verifying the email exists in the system
  */
  verifyEmail(event: any) {
    this.tmssLoader.show();
    this.customerRegistrationService.getEmailBusinessTypeCheck(this.customerRegistrationForm.controls['email'].value, this.customerRegistrationForm.controls['businessType'].value)
      .subscribe(emailExists => {
        this.emailPresent = emailExists;
        this.tmssLoader.hide();
      }, error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while checking email.');
      });
    if (this.emailPresent) {
      this.customerRegistrationForm.controls['userRegisterId'].setErrors(null);
    } else {
      const email = this.customerRegistrationForm.controls['email'].value;
      const splitted = email.split('@');
      const length = (splitted.length);
      const domain = splitted[length - 1];
      if (domain === 'hotmail.com' || domain === 'gmail.com' || domain === 'yahoo.com' || domain === 'msn.com' ||
        domain === 'comcast.com' || domain === 'cox.com' || domain === 'verizon.com') {
        this.customerRegistrationForm.controls['email'].setErrors({'invalid': true});
      }
    }
  }

  /*
  * check the registration type
  */
  selectRegisterType() {
    if (this.customerRegistrationForm.controls['registrationType'].value === 'User') {
      this.customerRegistrationForm.controls['title'].setErrors(null);
      this.customerRegistrationForm.controls['addressLine1'].setErrors(null);
      this.customerRegistrationForm.controls['city'].setErrors(null);
      this.customerRegistrationForm.controls['state'].setErrors(null);
      this.customerRegistrationForm.controls['zip'].setErrors(null);
      this.customerRegistrationForm.controls['country'].setErrors(null);
      this.customerRegistrationForm.controls['frtAccess'].setErrors(null);
      this.customerRegistrationForm.controls['hhgAccess'].setErrors(null);
      this.customerRegistrationForm.controls['permissions'].setErrors(null);
      this.customerRegistrationForm.controls['frtAccess'].setValidators([]);
      this.customerRegistrationForm.controls['hhgAccess'].setValidators([]);
      this.customerRegistrationForm.controls['permissions'].setValidators([]);
    } else {
      this.customerRegistrationForm.controls['frtAccess'].setValidators([Validators.required]);
      this.customerRegistrationForm.controls['hhgAccess'].setValidators([Validators.required]);
      this.customerRegistrationForm.controls['permissions'].setValidators([Validators.required]);
    }
    if (this.customerRegistrationForm.controls['registrationType'].value === 'Reporting Official') {
      this.customerRegistrationForm.controls['reportingOfficialId'].setErrors(null);
    }
    if (this.customerRegistrationForm.controls['registrationType'].value !== null) {
      this.getAgencyList();
    }
    return this.customerRegistrationForm.controls['registrationType'].value;
  }

  /*getting agency drop down */
  getAgencyList() {
    if (this.customerRegistrationForm.controls['registrationType'].value !== null) {
      this.tmssLoader.show();
      this.customerRegistrationService.getAllAgency().subscribe(
        agencys => {
          this.agencyMaster = agencys;
          this.tmssLoader.hide();
          return this.agencyMaster;
        }, (error) => {
          this.tmssLoader.hide();
          this.alertService.error('Agency drop down did not get populated');
        });
    }
  }

  /*
  *  Agency is selected, populatate the Bureau
  */
  changeAgency(event: any) {
    this.customerRegistrationForm.get('agency').setValue(event.item.agencyBureauName + ' - ' + event.item.agencyCode);
    this.customerRegistrationForm.get('agencyName').setValue(event.item.agencyBureauName);
    this.customerRegistrationForm.get('agencyCode').setValue(event.item.agencyCode);
    if (event.item.agencyCode !== null) {
      this.getBureauList(event.item.agencyCode);
    }
  }

  /*
  * Getting Bureau drop down
  */
  getBureauList(agencyCode) {
    this.tmssLoader.show();
    const bureauMaster = [];
    this.customerRegistrationService.getAllBureauForAgency(agencyCode).subscribe(
      bureaus => {
        this.bureauMaster = bureaus;
        this.tmssLoader.hide();
        return this.bureauMaster;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Bureau drop down did not get populated');
      });
  }

  /*
  * Change Bureau triggers to populate Reporting Official
  */
  changeBureau($event) {
    if (this.customerRegistrationForm.controls['bureauCode'].value !== null &&
      this.customerRegistrationForm.controls['agencyCode'].value !== null &&
      this.customerRegistrationForm.controls['registrationType'].value === 'User') {
      this.getROList(this.customerRegistrationForm.controls['agencyCode'].value,
        this.customerRegistrationForm.controls['bureauCode'].value);
    }

    if (this.customerRegistrationForm.controls['registrationType'].value === 'Reporting Official') {
      this.customerRegistrationForm.controls['reportingOfficialId'].setErrors(null);
      this.getStateList();
      /*this.getCountryList();
      this.customerRegistrationForm.controls['country'].setValue(null);*/
    }
  }

  /*
  *  Reporting Officieal drop down list
  */
  getROList(agencyCode, bureauCode) {
    this.tmssLoader.show();
    this.showDropDownMessage = false;
    this.customerRegistrationService.getAllReportingOfficial(agencyCode, bureauCode).subscribe(
      repOfficials => {
        this.repOfficialList = repOfficials;
        this.showDropDownMessage = repOfficials.length === 0;
        repOfficials.forEach(repRec => {
        });
        this.tmssLoader.hide();
        return this.repOfficialList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Reporting Official List did not get populated');
      });
  }

  // check and needs to be deleted
  changeRO($event) {
    return this.customerRegistrationForm.controls['reportingOfficialId'].value;
  }

  /*
  *Populating State in the drop down
  */
  getStateList() {
    this.tmssLoader.show();
    this.stateCountryType = 'State';
    this.customerRegistrationService.getAllStates(this.stateCountryType).subscribe(
      states => {
        this.stateList = states;
        this.tmssLoader.hide();
        return this.stateList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('State drop down did not get populated');
      });
  }

  /*
  * Populating Country in the drop down list
  */
  getCountryList() {
    this.tmssLoader.show();
    const countryList = [];
    this.stateCountryType = 'Country';
    this.customerRegistrationService.getAllStates(this.stateCountryType).subscribe(
      countries => {
        this.countryListObs.next(countries);
        this.countryList = countries;
        this.tmssLoader.hide();
        return this.countryList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Country drop down did not get populated');
      });
  }

  /*
  * Zipcode search populates city and state
  */
  getCityState($event) {
    const zip = this.customerRegistrationForm.get('zip').value;
    if (AppConstants.isNotNullCondition(zip) && zip.length > 4) {
      this.tmssLoader.show();
      this.customerRegistrationService.getCityState(zip).subscribe(uspsDetails => {
        this.uspsData = uspsDetails;
        this.customerRegistrationForm.controls['city'].setValue(this.uspsData.cityName);
        this.customerRegistrationForm.controls['state'].setValue(this.uspsData.stateId);
        this.customerRegistrationForm.controls['country'].setValue('326');
        this.tmssLoader.hide();
      }, error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while getting city and state.');
      });
    }
  }

  /*
  * Get Registration Details when the user enters the Registration Id.
  */
  getRegistrationDetails(registrationId?) {
    this.tmssLoader.show();
    this.registerDetails = this.customerRegistrationService.getCustomerDetails(registrationId !== null && registrationId !== undefined ? registrationId : this.customerRegistrationForm.controls['userRegisterId'].value)
      .subscribe(registerationDetails => {
        this.registerDetails = registerationDetails;
        if (this.registerDetails.userRegisterId !== 0 && (this.customerRegistrationForm.get('email').value.toUpperCase() === this.registerDetails.email.toUpperCase())) {
          this.customerRegistrationForm.controls['userConfirmation'].setValue('Yes');
          this.registrationStatus = registerationDetails.registrationStatus;
          // if (this.registerDetails.userRegisterId !== 0 && (this.customerRegistrationForm.get('email') === this.registerDetails.email)) {
          this.selectedRegisterId = this.registerDetails.userRegisterId;
          this.customerRegistrationForm.controls['registrationType'].setValue(this.registerDetails.registrationType);
          this.customerRegistrationForm.controls['registerTypeReadOnly'].setValue(this.registerDetails.registrationType);
          if (this.registerDetails.registrationType === 'User') {
            this.customerRegistrationForm.controls['registerTypeReadOnly'].setValue('Agency User');
          }
          this.customerRegistrationForm.controls['agencyCode'].setValue(this.registerDetails.agencyCode);
          this.customerRegistrationForm.controls['agency'].setValue(this.registerDetails.agencyName + ' - ' + this.registerDetails.agencyCode);
          this.customerRegistrationForm.controls['agencyCodeReadOnly'].setValue(this.registerDetails.agencyName + ' - ' + this.registerDetails.agencyCode);
          this.customerRegistrationForm.controls['bureauCode'].setValue(this.registerDetails.bureauCode);
          this.customerRegistrationForm.controls['bureauCodeReadOnly'].setValue(this.registerDetails.agencyBureauName + ' - ' + this.registerDetails.bureauCode);
          this.customerRegistrationForm.controls['firstName'].setValue(this.registerDetails.firstName);
          this.customerRegistrationForm.controls['lastName'].setValue(this.registerDetails.lastName);
          this.customerRegistrationForm.controls['middleInitial'].setValue(this.registerDetails.middleInitial);
          this.customerRegistrationForm.controls['title'].setValue(this.registerDetails.title);
          this.customerRegistrationForm.controls['addressLine1'].setValue(this.registerDetails.addressLine1);
          this.customerRegistrationForm.controls['addressLine2'].setValue(this.registerDetails.addressLine2);
          this.customerRegistrationForm.controls['city'].setValue(this.registerDetails.city);
          this.customerRegistrationForm.controls['state'].setValue(this.registerDetails.stateId);
          this.customerRegistrationForm.controls['zip'].setValue(this.registerDetails.zip);
          this.customerRegistrationForm.controls['zipSuffix'].setValue(this.registerDetails.zipSuffix);
          this.customerRegistrationForm.controls['country'].setValue(this.registerDetails.countryId);
          this.customerRegistrationForm.controls['phone'].setValue(this.registerDetails.phone);
          this.customerRegistrationForm.controls['phoneExtension'].setValue(this.registerDetails.phoneExtension);
          this.customerRegistrationForm.controls['email'].setValue(this.registerDetails.email);
          this.customerRegistrationForm.controls['emailReadonly'].setValue(this.registerDetails.email);
          this.customerRegistrationForm.controls['businessType'].setValue(this.registerDetails.accessRequested);
          if (this.registerDetails.accessRequested === 'FRT') {
            this.customerRegistrationForm.controls['permissionReadOnly'].setValue('Freight');
          } else if (this.registerDetails.accessRequested === 'HHG') {
            this.customerRegistrationForm.controls['permissionReadOnly'].setValue('Household Goods');
          } else if (this.registerDetails.accessRequested === 'HHG & FRT') {
            this.customerRegistrationForm.controls['permissionReadOnly'].setValue('Household Goods & Freight');
          }
          if (this.registerDetails.confirmDate === null) {
            this.confirmDateValue = 0;
          } else {
            this.confirmDateValue = (this.registerDetails.confirmDate);
          }
          if (this.customerRegistrationForm.controls['registerTypeReadOnly'].value === 'Agency User') {
            this.customerRegistrationForm.controls['reportingOfficialId'].setValue(this.registerDetails.reportingOfficialId);
            this.customerRegistrationForm.controls['title'].setErrors(null);
            this.customerRegistrationForm.controls['addressLine1'].setErrors(null);
            this.customerRegistrationForm.controls['city'].setErrors(null);
            this.customerRegistrationForm.controls['state'].setErrors(null);
            this.customerRegistrationForm.controls['zip'].setErrors(null);
            this.customerRegistrationForm.controls['country'].setErrors(null);
          }
          this.customerRegistrationForm.controls['agencyCode'].setErrors(null);
          this.customerRegistrationForm.controls['bureauCode'].setErrors(null);
          this.customerRegistrationForm.controls['reportingOfficialId'].setErrors(null);
          this.customerRegistrationForm.controls['userPermission'].setErrors(null);
          this.customerRegistrationForm.controls['registrationType'].setErrors(null);
          this.customerRegistrationForm.controls['email'].setErrors(null);
          this.customerRegistrationForm.controls['frtAccess'].setErrors(null);
          this.customerRegistrationForm.controls['hhgAccess'].setErrors(null);
          this.customerRegistrationForm.controls['permissions'].setErrors(null);
          if (this.customerRegistrationForm.controls['registerTypeReadOnly'].value === 'Reporting Official') {
            this.getStateList();
            // this.getCountryList();
          }
          this.tmssLoader.hide();
        } else {
          /*this.confirmDateValue = 0;*/
          this.selectedRegisterId = 0;
          this.customerRegistrationForm.controls['registerTypeReadOnly'].setValue('');
          this.tmssLoader.hide();
        }
      });
    // return this.registerDetails;
  }

  /*
  * Retrieving the information of the Reporting official details
  */
  /*
   getReportingOfficialDetails(roId) {
     this.tmssLoader.show();
     this.organizationDetails = this.customerRegistrationService.getReportingOfficial(roId).subscribe(
         orgDetails => {
           this.organizationDetails = orgDetails;
           this.customerRegistrationForm.controls['repOfficialReadOnly']
               .setValue(this.organizationDetails.city + ', ' + this.organizationDetails.stateName + ' - '
                   + this.organizationDetails.lastName + ', ' + this.organizationDetails.firstName);
           this.tmssLoader.hide();
         }, error => {
           this.tmssLoader.hide();
           this.alertService.error('Error while getting reporting official details.');
         });
     return this.organizationDetails;
   }
   */

  /*
  * This validates any validation errors
  */
  public markControlsAsTouched(rootControl: UntypedFormGroup | UntypedFormArray,
                               visitChildren: boolean = true) {

    const stack: (UntypedFormGroup | UntypedFormArray)[] = [];

    // Stack the root FormGroup or FormArray
    if (rootControl &&
      (rootControl instanceof UntypedFormGroup || rootControl instanceof UntypedFormArray)) {
      stack.push(rootControl);
    }
    while (stack.length > 0) {
      const currentControl = stack.pop();
      (<any>Object).values(currentControl.controls).forEach((control) => {
        // If there are nested forms or formArrays, stack them to visit later
        if (visitChildren &&
          (control instanceof UntypedFormGroup || control instanceof UntypedFormArray)
        ) {
          stack.push(control);
        } else {
          control.markAsTouched();
          control.setErrors(null);
        }
      });
    }
  }

  /*
  * Registration Submit action
  */
  registerCustomer(form) {
    form.userRegisterId = 0;
    if (this.customerRegistrationForm.get('registrationType').value === 'User') {
      const orgId = this.customerRegistrationForm.get('reportingOfficialId').value;
      const reportingOfficial = this.repOfficialList.find(x => x.organizationId === parseInt(orgId));
      form.accessRequested = reportingOfficial.permission ? reportingOfficial.permission : '';
    } else {
      if(form.permissions){
        form.accessRequested = form.permissions;
        form.frtAccess = false;
        form.hhgAccess = false;
        if (form.permissions === 'FRT'){
          form.frtAccess = true;
        }
        if (form.permissions === 'HHG'){
          form.hhgAccess = true;
        }
      }
      /*if (form.frtAccess && form.hhgAccess) {
        form.accessRequested = 'HHG & FRT';
      } else if (form.frtAccess) {
        form.accessRequested = 'FRT';
      } else if (form.hhgAccess) {
        form.accessRequested = 'HHG';
      }*/
    }
    // form.stateId = this.customerRegistrationForm.controls['state'].value;
    form.countryId = this.customerRegistrationForm.controls['country'].value;
    form.registrationStatus = 'Confirm Pending';
    form.createdDate = 0;
    form.confirmDate = 0;
    form.updateProgram = 'Customer Registration';
    form.updateId = '';
    form.updateDate = 0;
    this.tmssLoader.show();
    this.registrationSuccessful = false;
    this.registrationFailure = false;
    this.savedCustomer = new CustomerRegistration();
    this.customerRegistrationService.createCustomer(form)
      .subscribe(response => {
          this.savedCustomer = response;
          this.registrationSuccessful = true;
          this.tmssLoader.hide();
          this.alertService.success2('Your registration request has been received. Please check your email for instructions on how to confirm your registration.');
          this.router.navigate(['/signon']);
        },
        err => {
          this.registrationFailure = true;
          this.registrationSuccessful = false;
          this.tmssLoader.hide();
          this.alertService.error('Error while creating the customer data.');
        });

    window.scroll(0, 0);
  }

  /*
  * User Confirm action
  */

  confirmCustomer(form) {
    if (this.customerRegistrationForm.controls['permissionReadOnly'].value === 'Freight') {
      form.accessRequested = 'FRT';
    } else if (this.customerRegistrationForm.controls['permissionReadOnly'].value === 'Household Goods') {
      form.accessRequested = 'HHG';
    } else if (this.customerRegistrationForm.controls['permissionReadOnly'].value === 'Household Goods & Freight') {
      form.accessRequested = 'HHG & FRT';
    }
    form.stateId = this.customerRegistrationForm.controls['state'].value;
    form.countryId = this.customerRegistrationForm.controls['country'].value;
    form.registrationStatus = 'Confirmed';
    form.confirmDate = 0;
    form.updateProgram = 'Customer Registration';
    form.updateId = '';
    form.updateDate = 0;
    form.userRegisterId = this.selectedRegisterId;

    this.tmssLoader.show();
    this.registrationSuccessful = false;
    this.registrationFailure = false;
    this.customerRegistrationService.updateCustomer(form)
      .subscribe(data => {
          if (data !== null) {
            this.savedCustomer = data;
            this.registrationSuccessful = true;
          } else {
            this.registrationFailure = true;
          }
          this.tmssLoader.hide();
        },
        err => {
          this.registrationFailure = true;
          this.tmssLoader.hide();
          this.alertService.error('Error in creating customer data.');
        });
    window.scroll(0, 0);
    return this.savedCustomer;
  }

  /*
  * When Reset button is clicked
  */
  clearPage() {
    // window.location.reload();
    this.customerRegistrationForm.get('userConfirmation').setValue('');
    this.registrationSuccessful = false;
    this.emailPresent = null;
    this.selectedRegisterId = null;
    this.registrationSuccessful = false;
    this.registrationStatus = null;
    this.createForm();
    window.scroll(0, 0);
    this.router.navigate(['/customerregistration']);
  }

  /**
   * @description listens to sountry changes and enables/disabels the controls.
   */
  onCountryChange() {
    this.customerRegistrationForm.get('zip').setValue(null);
    this.customerRegistrationForm.get('state').setValue(null);
    this.customerRegistrationForm.get('city').setValue(null);
    const country = this.customerRegistrationForm.get('country').value;
    if (country !== '326') {
      this.isCountryUsa = false;
      this.customerRegistrationForm.get('state').disable();
      this.customerRegistrationForm.get('zip').disable();
      this.customerRegistrationForm.get('state').clearValidators();
      this.customerRegistrationForm.get('zip').clearValidators();
    } else {
      this.isCountryUsa = true;
      this.customerRegistrationForm.get('state').enable();
      this.customerRegistrationForm.get('zip').enable();
      this.customerRegistrationForm.get('state').setValidators([Validators.required]);
      this.customerRegistrationForm.get('zip').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5), CommonValidators.numeric]);
    }
  }

  onContactTypeChg(contactType: any) {
    console.log(this.customerRegistrationForm.value);
    this.customerRegistrationForm.get('businessType').setValue(contactType);
  }

  /**
   *  validating for testing purpose only it will return invalid fields
   */
  validateForm() {
    AppConstants.getFormValidationErrors(this.customerRegistrationForm);
  }

  ngOnDestroy(): void {
    this.countryListObs.unsubscribe();
  }

}
